// @flow
import * as React from 'react';
import { useSelector } from 'react-redux';

import { ReactPageContext } from 'Context/pageContext';
import ReactAppContext from 'Context/ReactAppContext';
import { GA_DEFAULT_PAYLOAD } from 'Tracking/constants';
import * as trackingApi from 'Tracking/tracking-api';
import { getLeadScore } from 'Store/lead-info/leadInfo.selector';

type Props = {
  children?: React.Node,
  // a string ('div' for instance) is a valid ComponentType
  as?: React.ComponentType<*>,
  onClick?: ?(e: SyntheticEvent<*>) => mixed,
  trackingData?: ?TrackingData,
  dataSelector?: string,
};

export const TrackClick = ({
  children,
  trackingData,
  as = 'div',
  onClick,
  dataSelector,
  ...props
}: Props) => {
  const appContext = React.useContext(ReactAppContext);
  const pageContext = React.useContext(ReactPageContext);
  const leadScoring = useSelector(getLeadScore);

  const trackEvent =
    onClick || trackingData
      ? e => {
          if (onClick) {
            onClick(e);
          }

          if (trackingData) {
            trackingApi.setDataLayer(
              {
                ...GA_DEFAULT_PAYLOAD,
                siteSection: pageContext.siteSection,
                ...trackingData,
                ...(leadScoring ? { leadScoring } : null),
              },
              appContext,
              pageContext.pageType,
            );
          }
        }
      : // undefined avoid adding onClick={null} in each snapshot
        undefined;

  const Comp = as;
  return (
    <Comp {...props} onClick={trackEvent} data-selector={dataSelector}>
      {children}
    </Comp>
  );
};
